import { render, staticRenderFns } from "./authLayout.vue?vue&type=template&id=30592a50&scoped=true&"
import script from "./authLayout.vue?vue&type=script&lang=js&"
export * from "./authLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30592a50",
  null
  
)

export default component.exports